import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

interface Props {
  handleChange: any;
  label: string;
  value?: boolean;
  error?: any;
  name?: string;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    // formControl: {
    //   margin: theme.spacing(3),
    // },
  })
);

export default function CommonCheckBox({ handleChange, label, value, error, name }: Props) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <FormControl error={error} component="fieldset">
        <FormControlLabel
          control={
            <Checkbox
              checked={value || false}
              onChange={handleChange}
              name={name}
              color={"primary"}
            />
          }
          label={label}
        />
        <FormHelperText>{error}</FormHelperText>
      </FormControl>
    </div>
  );
}
